module.exports = __webpack_public_path__ + "assets/img/69_519.b964be77.jpg";